import React, { useState } from "react";
import CreateInvoice from "../../../../../entities/DashboardPage/AccountingModule/Customer/CreateInvoice";
import AuthService from "../../../../../api/AuthService";
import { useNavigate } from "react-router-dom";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const CreateInvoicePage = () => {
  const {showAlert} = useAlert();
  const navigate = useNavigate();

  const [loading,setLoading] = useState(false);


  const handleAddNewInvoice = async (data) => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleInvoice(data);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message,"success");
        navigate("/dashboard/invoice")


      } else {
        
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message,"error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);

      showAlert(error,"error");
    }
  };
  return (
    <CreateInvoice  handleAddNewInvoice={handleAddNewInvoice} loading={loading}/>
  )

}

export default CreateInvoicePage;
